import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { AssetManagement, Header } from '@aptsi-types';

import { MatDialog } from '@angular/material/dialog';



import { SystemAssetSourceService } from './services/system-asset-source.service'

import { KeycloakStateService } from 'src/app/core/service/utility.service';

import { DeleteDialogComponent } from 'src/app/shared/dialogs/delete-dialog/delete-dialog.component';

// import { AddAssetDialogComponent } from '../../dialogs/add-asset-dialog/add-asset-dialog.component';

import { SystemAssetsViewComponent } from './system-assets-view/system-assets-view.component';
import { SystemAssetsCaptureForAssetSourceComponent } from './system-assets-capture-for-asset-source/system-assets-capture-for-asset-source.component';

import {
  SystemAssetsCaptureForFileAssetSourceComponent
} from './system-assets-capture-for-file-asset-source/system-assets-capture-for-file-asset-source.component';
import { WorkflowNavigationService } from '../shared/workflow-navigation.service';

interface AssetSourcePaginationMeta {

  totalAssetSources?: number;

  totalPages?: number;

  currentPage?: number;

}



type AssetManagementWithMeta = AssetManagement & AssetSourcePaginationMeta;



@Component({

  selector: 'app-system-asset-capture',

  templateUrl: './system-asset-capture.component.html',

  styleUrls: ['./system-asset-capture.component.scss'],

})

export class SystemAssetCaptureComponent implements OnInit {

  readonly itemsPerPage = 10;



  currentPage = 1;

  totalPages = 0;

  totalPagesNormal = 0;

  totalPagesSearch = 0;

  totalItemsNormal = 0;

  totalItemsSearch = 0;



  isAdd = false;

  issearch = false;

  isLoading = true;

  isSearching = false;

  loadError = false;

  searchError = false;

  hasSystemAssetSources = false;



  searchText = '';

  filterByHeader = 'all';

  nullver = 1;

  check = '';



  private readonly sessionId: string;

  private readonly userId: string;

  private readonly transactionId: string;

  /** Prevent a slower, older request from overwriting the latest page/search result. */
  private requestSequence = 0;



  filteredData: AssetManagement[] = [];

  searchedData: AssetManagement[] = [];



  get displayedData(): AssetManagement[] {

    return this.issearch ? this.searchedData : this.filteredData;

  }



  readonly headers: Header[] = [

    {

      name: 'Asset Source Id',

      property: 'assetSourceId',

      showInDropdown: true,

      description: 'Unique identifier for the asset source',

    },

    {

      name: 'Asset Source Name',

      property: 'assetSourceName',

      showInDropdown: true,

      description: 'Name of the asset source',

    },

    {

      name: 'Asset Source',

      property: 'assetSource',

      showInDropdown: true,

      description: 'Source of the asset',

    },

    {

      name: 'Asset Source Type',

      property: 'assetSourceType',

      showInDropdown: true,

      description: 'Type of the asset source',

    },

    {

      name: 'Asset Type',

      property: 'assetType',

      // Search is scoped to System sources, so this column is not a useful filter.

      showInDropdown: false,

      description: 'Type of the asset',

    },

    {

      name: 'Last Updated',

      property: 'updatedAt',

      showInDropdown: true,

      description: 'Date and time when the asset source was last updated',

    },



  ];



  readonly filterOptions: Record<string, { value: string; label: string }[]> = {

    assetSourceType: [

      { label: 'CICD', value: 'CICD' },

      { label: 'CMDB', value: 'CMDB' },

      { label: 'DBCONFIG', value: 'DBCONFIG' },

      { label: 'DATA_GOVERNANCE', value: 'DATA_GOVERNANCE' },

      { label: 'MANUAL_ENTRY', value: 'MANUAL_ENTRY' },

      { label: 'FILE', value: 'FILE' },

    ],

    // The screen is dedicated to system sources; do not offer DATA as a search option.

    assetType: [{ label: 'System', value: 'system' }],

  };



  readonly buttonConfig = {

    update: true,

    delete: true,

    import: true,

    configure: false,

    view: true

  };



  constructor(

    private readonly router: Router,

    private readonly route: ActivatedRoute,

    private readonly systemAssetSourceService: SystemAssetSourceService,

    private readonly dialog: MatDialog,

    keycloakStateService: KeycloakStateService,
    private readonly workflowNavigation: WorkflowNavigationService

  ) {

    this.sessionId = keycloakStateService.getSessionId();

    this.userId = keycloakStateService.getUserId();

    this.transactionId = keycloakStateService.getTransactionId();

  }



  ngOnInit(): void {

    this.isAdd = this.route.snapshot.queryParamMap.get('isAdd') === 'true';

    void this.fetchAssetSources();

  }



  /**
 
  * Handles row-level actions emitted by the shared table.
 
  */

  handleAction(event: {

    action: string;

    rowIndex: number;

    rowData: AssetManagement;

  }): void {

    switch (event.action) {

      case 'update':

        void this.updateAssetSource(event.rowIndex);

        break;



      case 'delete':

        void this.deleteAssetSource(event.rowIndex);

        break;



      case 'import':

        void this.captureAssetSource(event.rowIndex);

        break;



      case 'view':

        this.viewSystemAssets(event.rowData);

        break;



      default:

        break;

    }

  }



  /** Fetch the current server page. The API receives a zero-based page index. */
  async fetchAssetSources(): Promise<void> {
    const requestId = ++this.requestSequence;
    const requestedPage = Math.max(1, Math.floor(Number(this.currentPage) || 1));

    this.currentPage = requestedPage;
    this.isSearching = false;
    this.isLoading = true;
    this.loadError = false;

    try {
      const apiResponse = await this.systemAssetSourceService
        .FetchSystemAssetSources(this.toApiPageIndex(requestedPage))
        .toPromise();

      // Ignore stale results if a newer pagination/search request has started.
      if (requestId !== this.requestSequence || this.issearch) {
        return;
      }

      const response: AssetManagementWithMeta[] = Array.isArray(apiResponse)
        ? (apiResponse as AssetManagementWithMeta[])
        : [];
      const metadata = response[0];

      // This endpoint is already paginated. Only keep System sources; do not
      // slice the current page again on the client.
      this.filteredData = response.filter((source) => this.isSystemAssetSource(source));

      const reportedTotalItems = this.readNonNegativeInteger(metadata?.totalAssetSources);
      const fallbackTotalItems = this.filteredData.length > 0
        ? this.filteredData.length
        : this.totalItemsNormal;

      // Keep the count at least as large as the current page, even if the API
      // accidentally reports zero while returning records.
      this.totalItemsNormal = Math.max(
        reportedTotalItems ?? fallbackTotalItems,
        this.filteredData.length,
      );

      const calculatedTotalPages = Math.ceil(this.totalItemsNormal / this.itemsPerPage);
      const reportedTotalPages = this.readPositiveInteger(metadata?.totalPages);
      this.totalPagesNormal = this.totalItemsNormal === 0
        ? 0
        : (reportedTotalPages ?? calculatedTotalPages);
      this.totalPages = this.totalPagesNormal;

      // Keep the UI's one-based page state; do not let stale/incorrect
      // currentPage metadata reset the page selected by the user.
      if (this.totalPagesNormal === 0) {
        this.currentPage = 1;
      } else if (requestedPage > this.totalPagesNormal) {
        // If the last record on the last page was deleted, reload the new last page.
        this.currentPage = this.totalPagesNormal;
        await this.fetchAssetSources();
        return;
      } else {
        this.currentPage = requestedPage;
      }

      // Base the empty state on the overall result count, not just the current
      // page. An empty/out-of-range page must not hide the list and paginator.
      this.hasSystemAssetSources = this.totalItemsNormal > 0;
    } catch (error) {
      if (requestId !== this.requestSequence) {
        return;
      }

      console.error('Error fetching system asset sources:', error);
      this.loadError = true;
      this.filteredData = [];
      this.hasSystemAssetSources = false;
      this.totalItemsNormal = 0;
      this.totalPagesNormal = 0;
      this.totalPages = 0;
      this.currentPage = 1;
    } finally {
      if (requestId === this.requestSequence) {
        this.isLoading = false;
      }
    }
  }

  /** Search results are server-paginated; don't filter the returned page again locally. */
  async fetchAssetSourcesSearch(): Promise<void> {
    const requestId = ++this.requestSequence;
    const requestedPage = Math.max(1, Math.floor(Number(this.currentPage) || 1));

    this.currentPage = requestedPage;
    this.isLoading = false;
    this.isSearching = true;
    this.searchError = false;

    try {
      const apiResponse = await this.systemAssetSourceService
        .FetchSysteAssetSourcesSearch(
          this.toApiPageIndex(requestedPage),
          this.searchText.trim(),
          this.filterByHeader,
        )
        .toPromise();

      // Ignore stale results if the user has since changed the page or query.
      if (requestId !== this.requestSequence || !this.issearch) {
        return;
      }

      const response: AssetManagementWithMeta[] = Array.isArray(apiResponse)
        ? (apiResponse as AssetManagementWithMeta[])
        : [];
      const metadata = response[0];
      this.searchedData = response.filter((source) => this.isSystemAssetSource(source));

      const reportedTotalItems = this.readNonNegativeInteger(metadata?.totalAssetSources);
      const fallbackTotalItems = this.searchedData.length > 0
        ? this.searchedData.length
        : this.totalItemsSearch;

      this.totalItemsSearch = Math.max(
        reportedTotalItems ?? fallbackTotalItems,
        this.searchedData.length,
      );

      const calculatedTotalPages = Math.ceil(this.totalItemsSearch / this.itemsPerPage);
      const reportedTotalPages = this.readPositiveInteger(metadata?.totalPages);
      this.totalPagesSearch = this.totalItemsSearch === 0
        ? 0
        : (reportedTotalPages ?? calculatedTotalPages);
      this.totalPages = this.totalPagesSearch;

      // Preserve the one-based page selected in the UI instead of resetting it
      // from response metadata that may be stale or inconsistently indexed.
      if (this.totalPagesSearch === 0) {
        this.currentPage = 1;
      } else if (requestedPage > this.totalPagesSearch) {
        this.currentPage = this.totalPagesSearch;
        await this.fetchAssetSourcesSearch();
        return;
      } else {
        this.currentPage = requestedPage;
      }
    } catch (error) {
      if (requestId !== this.requestSequence) {
        return;
      }

      console.error('Error searching system asset sources:', error);
      this.searchError = true;
      this.searchedData = [];
      this.totalItemsSearch = 0;
      this.totalPagesSearch = 0;
      this.totalPages = 0;
      this.currentPage = 1;
    } finally {
      if (requestId === this.requestSequence) {
        this.isSearching = false;
      }
    }
  }

  async searchAssetSources(): Promise<void> {

    const query = this.searchText.trim();



    if (!query) {

      await this.clearSearch();

      return;

    }



    this.searchText = query;
    this.issearch = true;
    this.currentPage = 1;

    // A new query has a new result set; don't reuse the previous query's totals.
    this.searchedData = [];
    this.totalItemsSearch = 0;
    this.totalPagesSearch = 0;

    await this.fetchAssetSourcesSearch();

  }



  async clearSearch(): Promise<void> {

    this.searchText = '';
    this.issearch = false;
    this.searchError = false;
    this.currentPage = 1;
    this.searchedData = [];
    this.totalItemsSearch = 0;
    this.totalPagesSearch = 0;

    await this.fetchAssetSources();

  }



  onInputChange(event: Event): void {

    this.searchText = (event.target as HTMLInputElement).value;

  }



  onFilterChange(): void {

    // Reset to page one so the normal list and its server metadata stay in sync.

    void this.clearSearch();

  }



  changePage(page: number): void {
    const totalPages = this.issearch ? this.totalPagesSearch : this.totalPagesNormal;

    if (
      !Number.isInteger(page) ||
      page < 1 ||
      page > totalPages ||
      page === this.currentPage
    ) {
      return;
    }

    this.currentPage = page;
    if (this.issearch) {
      void this.fetchAssetSourcesSearch();
    } else {
      void this.fetchAssetSources();
    }
  }





  // private async checkForSystemAssetSources(): Promise<boolean> {

  //   const apiResponse = await this.assetmanagementService

  //     .getAssetSourcesSearch(0, 'system', 'assetType')

  //     .toPromise();

  //   const response = Array.isArray(apiResponse) ? apiResponse : [];

  //   return response.some((source) => this.isSystemAssetSource(source));

  // }



  private isSystemAssetSource(source: AssetManagement): boolean {

    return String((source as unknown as Record<string, unknown>)['assetType'] ?? '').toLowerCase() === 'system';

  }



  /** Convert the one-based UI page to the zero-based API page index. */
  private toApiPageIndex(uiPage: number): number {
    return Math.max(0, Math.floor(uiPage) - 1);
  }

  private readNonNegativeInteger(value: unknown): number | undefined {
    if (value === null || value === undefined || value === '') {
      return undefined;
    }

    const parsed = Number(value);
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : undefined;
  }

  private readPositiveInteger(value: unknown): number | undefined {
    const parsed = this.readNonNegativeInteger(value);
    return parsed !== undefined && parsed > 0 ? parsed : undefined;
  }



  /**

 * Opens a popup displaying the system assets belonging to the selected source.

 */

  private viewSystemAssets(assetSource: AssetManagement): void {

    const assetSourceId = String(assetSource.assetSourceId ?? '').trim();



    if (!assetSourceId) {

      console.error(

        'Cannot view system assets: assetSourceId is missing.',

        assetSource

      );

      return;

    }



    this.dialog.open(SystemAssetsViewComponent, {

      width: '95vw',

      maxWidth: '1500px',

      maxHeight: '95vh',

      autoFocus: false,

      data: {

        assetSourceId,

        assetSourceName: assetSource.assetSourceName ?? ''

      }

    });

  }



  async deleteAssetSource(index: number): Promise<void> {

    const source = this.displayedData[index];

    if (!source?.assetSourceId) {

      return;

    }



    try {

      const dialogRef = this.dialog.open(DeleteDialogComponent, {

        data: {

          title: 'Are you sure?',

          message: 'Do you really want to delete this System Asset Source?',

          isConfirm: false,

        },

      });

      const confirmed = await dialogRef.afterClosed().toPromise();



      if (!confirmed) {

        return;

      }



      await this.systemAssetSourceService.deleteAssetSource(source.assetSourceId).toPromise();

      this.issearch = false;

      this.searchText = '';

      this.currentPage = 1;

      await this.fetchAssetSources();



      this.dialog.open(DeleteDialogComponent, {

        data: {

          title: 'Success',

          message: 'The System Asset Source has been deleted successfully.',

          isConfirm: true,

        },

      });

    } catch (error) {

      console.error('Error deleting system asset source:', error);

    }

  }



 async captureAssetSource(index: number): Promise<void> {
  const source = this.displayedData[index];

  if (!source?.assetSourceId) {
    return;
  }

  const assetSourceType = String(
    source.assetSourceType ?? ''
  ).trim().toUpperCase();

  if (assetSourceType === 'FILE') {
    this.dialog.open(SystemAssetsCaptureForFileAssetSourceComponent, {
      width: '1100px',
      maxWidth: '96vw',
      maxHeight: '94vh',
      autoFocus: false,
      disableClose: true,
      data: {
        assetSourceId: String(source.assetSourceId),
        assetSourceName: source.assetSourceName ?? '',
        assetSourceType: source.assetSourceType ?? '',
        assetSource: source.assetSource ?? ''
      }
    });

    return;
  }

  // Keep the existing non-file import workflow.
  const dialogRef = this.dialog.open(
    SystemAssetsCaptureForAssetSourceComponent,
    {
      width: '520px',
      maxWidth: '94vw',
      maxHeight: '90vh',
      autoFocus: false,
      disableClose: true,
      data: {
        assetSourceId: String(source.assetSourceId),
        assetSourceName: source.assetSourceName ?? ''
      }
    }
  );

  dialogRef.afterClosed().subscribe(
    (result?: { shouldViewSystemAssets?: boolean }) => {
      if (result?.shouldViewSystemAssets) {
        this.viewSystemAssets(source);
      }
    }
  );
}

  // fileImport(assetSourceId: string, assetSource: string): void {

  //   this.dialog.open(AddAssetDialogComponent, {

  //     width: '400px',

  //     data: {

  //       assetSourceId,

  //       assetSource,

  //       title: 'Upload File',

  //       message: 'To import assets from the file',

  //     },

  //   });

  // }



/**
 * Update an existing system asset source.
 */
updateAssetSource(index: number): void {
  const source = this.displayedData[index];
  const assetSourceId = String(source?.assetSourceId ?? '').trim();

  if (!assetSourceId) {
    return;
  }

  const isFileSource =
    String(source?.assetSourceType ?? '').trim().toUpperCase() === 'FILE';

  if (isFileSource) {
    void this.router.navigate(['file', 'update', assetSourceId], {
      relativeTo: this.route,
    });
  } else {
    void this.router.navigate(['update', assetSourceId], {
      relativeTo: this.route,
    });
  }
}

/**
 * Return to the system asset source list.
 * If a search is active, clear it first.
 */
back(): void {
  if (this.issearch) {
    void this.clearSearch();
    return;
  }

  void this.workflowNavigation.navigateToProductHome();
}

/**
 * Navigate to create a system asset source using a file.
 */
addAssetThroughFile(): void {
  void this.router.navigate(['file', 'create'], {
    relativeTo: this.route,
    queryParams: { isAdd: true },
  });
}

/**
 * Navigate to manually create a system asset.
 */
addManualAsset(): void {
  void this.router.navigate(['asset-create'], {
    relativeTo: this.route,
    queryParams: { isAdd: true },
  });
}

/**
 * Navigate to create a system asset source.
 */
createAssetSource(): void {
  void this.router.navigate(['create'], {
    relativeTo: this.route,
    queryParams: { isAdd: true },
  });
}

/**
 * Return to the source list without navigating away.
 */
backToSourceList(): void {
  this.isAdd = false;
}







  addAssetSource(): void {

    this.isAdd = true;

  }





}
